<template>
  <div class="content" style="display: flex;height: 80vh;align-items: center;justify-content: space-around;">
    <card class="mt-2" style="border-radius: 24px;background-blend-mode: darken;overflow:hidden;height:40%; width: 30%;"
      card-body-classes="pt-0">
      <router-link to="/fitnessvideos">
        <img src="@/assets/img/fitness.gif"
          style="position: absolute;top: 0;left: 0px;height: 100%;filter: brightness(0.5);" />
        <h2 style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);color: white;font-weight: 500;">
          {{$t("message.Fitness")}}</h2>
      </router-link>
    </card>
    <card class="mt-2" style="border-radius: 24px;background-blend-mode: darken;overflow:hidden;height:40%; width: 30%;"
      card-body-classes="pt-0">
      <router-link to="/yogavideos">
        <img src="@/assets/img/yoga.gif"
          style="position: absolute;top: 0;left: 0px;height: 100%;filter: brightness(0.5);" />
        <h2 style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);color: white;font-weight: 500;">
          {{$t("message.Yoga")}}</h2>
      </router-link>
    </card>
    <card class="mt-2" style="border-radius: 24px;background-blend-mode: darken;overflow:hidden;height:40%; width: 30%;"
      card-body-classes="pt-0">
      <router-link to="/nutritionhome">
        <img src="@/assets/img/nutrition.gif"
          style="position: absolute;top: 0;left: 0px;height: 100%;filter: brightness(0.5);" />
        <h2 style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);color: white;font-weight: 500;">
          {{$t("message.Nutrition")}}</h2>
      </router-link>
    </card>
  </div>
</template>
<script>
import Card from "../../../components/Cards/Card.vue";

export default {
  name: "wellness",
  components: {
    Card
  }
}
</script>
